import { getEntitySubdomain } from '@opengov/app-core/entity';
import { List } from 'immutable';
import { IRecordOf } from '@opengov/compose-app/immutable';
import { createSelector } from '@opengov/compose-app/reselect';
import { ICurrentOrLegacyReport } from '@opengov/reporting-types';

import { currentOrLegacyReportSelector } from '../state/currentOrLegacyReportState';

export const selectCurrentOrLegacyReports = createSelector(currentOrLegacyReportSelector, (state) => state.reports);

export const selectCurrentOrLegacyReportsSortedByName = createSelector(
  selectCurrentOrLegacyReports,
  (reports: List<IRecordOf<ICurrentOrLegacyReport>>) => reports.sortBy((report) => report.name)
);

export const areCurrentOrLegacyReportsLoading = createSelector(
  currentOrLegacyReportSelector,
  (state) => state.loadingReports.active
);

export const selectCurrentOrLegacyReportsLoadingError = createSelector(
  currentOrLegacyReportSelector,
  (state) => state.loadingReports.error
);

export const selectLegacyReportingHref = createSelector(getEntitySubdomain, (subdomain) =>
  subdomain ? `${window.location.origin}/reports#/${subdomain}` : null
);
